










































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import GoodsApi from '@/api/goods/list/index'
import CustomForm from '@/components/custom-form/index.vue'
import appconst from '@/lib/appconst'
import OutfitClassifyApi from '@/api/goods/outfitClassify/index'
import OutfitApi from '@/api/goods/outfitlist/index'
@Component({
  components: {
    CustomForm,
  },
})
export default class GoodsSelect extends Vue {
  // 选择的商品Id
  @Prop({
    type: Array,
    default: () => {
      return []
    },
  })
  selectedItems!: string[]

  // 是否显示按钮
  @Prop({
    type: Boolean,
    default: false,
  })
  showBtn!: boolean
  // 是否显示导入按钮
  @Prop({
    type: Boolean,
    default: false,
  })
  isShow?: boolean
  // 按钮文字
  @Prop({
    type: String,
    default: '选择套装',
  })
  btnText!: string

  @Prop({
    type: Boolean,
    default: false,
  })
  show!: boolean

  @Prop({
    type: Boolean,
    default: false,
  })
  IsMultiple!: boolean

  // 默认查上架商品 true 上架 false 下架 null 全部
  @Prop({
    type: Boolean,
    default: true,
  })
  IsPublished!: boolean

  @Prop({
    type: String,
    default: '',
  })
  Source!: string

  @Prop({
    type: String,
    default: 'promotion',
  })
  ImportType!: string

  @Watch('show')
  showChange(show) {
    this.modal1 = !this.modal1
  }

  modal1: boolean = false
  total: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  data = []
  uploadUrl = ''
  templateUrl = ''
  // uploadData = {}
  // requestHeader = {}
  uploadFile = ''
  filters = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '套装名称',
      },
      key: 'keyWord',
    },
    {
      label: '套装分组',
      type: 'select',
      props: {
        placeholder: '请选择套装分组',
      },
      key: 'GroupId',
      defaultValue: [],
      options: [],
    },
  ]
  get columns() {
    var data: any[] = [
      {
        title: '套装名称',
        key: 'name',
        align: 'center',
      },
      {
        title: '套装分组',
        key: 'groupName',
        align: 'center',
      },
      {
        title: '套装价格',
        key: 'outfitPrice',
        align: 'center',
      },
      {
        title: '套装产品图',
        slot: 'outfitPictureUrl',
        align: 'center',
      },
      // {
      //   title: '商品图',
      //   slot: 'pictureUrl',
      //   align: 'center',
      // },
      // {
      //   title: '商品名称',
      //   slot: 'productName',
      //   align: 'center',
      // },
      // {
      //   title: '商品价格',
      //   slot: 'price',
      //   align: 'center',
      // },
    ]
    if (this.IsMultiple) {
      data.splice(0, 0, {
        type: 'selection',
        width: 60,
        align: 'center',
      })
    }
    return data
  }
  async mounted() {
    this.getGroupList()
  }
  @Watch('modal1')
  modalShowChange(show) {
    if (show) this.submitFn()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  submitChange(form, valid) {
    if (valid) {
      this.loadGoodsList(form)
    }
  }

  async loadGoodsList(form?) {
    let keyWord = form['keyWord']
    let groupId = form['GroupId']
    let { pageSize, pageIndex } = this
    OutfitApi.getProductOutfitList(pageIndex, pageSize, keyWord, null, groupId)
      .then((res) => {
        let { totalCount, items } = res.data
        this.total = totalCount
        this.data = items
      })
      .catch(() => {
        this.total = 0
        this.data = []
      })
  }

  /**
   * 获取套装分组
   */
  getGroupList() {
    OutfitClassifyApi.getAllgroupList().then((res) => {
      this.filters.find((item) => item.label == '套装分组').options = res.data.map((item) => {
        return {
          value: item.id,
          text: item.groupName,
        }
      })
    })
  }

  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
    await this.submitFn()
  }
  currentChange(currentRow) {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', currentRow)
      this.modal1 = false
    }
  }
  ok() {
    this.$emit('on-change', (this.$refs.selection as any).getSelection(), 'selectGoods')
    this.modal1 = false
  }

  cancel() {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', null)
    } else {
      this.$emit('on-change', [])
    }
    this.modal1 = false
  }

}
